import { z } from "zod";

export const ChangePasswordSchema = z.object({
    old_password: z.string().min(8).max(255),
    new_password: z.string().min(8).max(255),
    confirm_new_password: z.string().min(8).max(255),
}).superRefine((data, ctx) => {
    if (data.new_password !== data.confirm_new_password) {
        ctx.addIssue({
            message: 'New password and confirm new password do not match',
            path: ['confirm_new_password'],
            code: z.ZodIssueCode.custom,
        });
    }
});

export type ChangePasswordType = z.infer<typeof ChangePasswordSchema>;